export default "__VITE_ASSET__BmfQhsRT__"